import { getPathWithRootPath } from '../../Services/common';
import { getInitials } from '../../Services/user';
import './biz-user-image.scss';

type userImageProps = {
	imageUrl: string | null | undefined;
	isOnline?: boolean;
	showOnlineStatus?: boolean;
	initials?: string;
	fullname?: string;
	size?: number | string; // Allow custom size (px, em, rem, etc.)
	badgePosition?: 'bottom-right' | 'top-right' | 'bottom-left' | 'top-left';
};

const BizUserImage = ({
	imageUrl,
	isOnline,
	showOnlineStatus,
	initials,
	fullname,
	size = 48,
	badgePosition = 'bottom-right',
}: userImageProps) => {
	const userInitials = initials || getInitials(fullname);

	const getUserImage = () => {
		if (imageUrl) return getPathWithRootPath(imageUrl, 'sm');

		if (!userInitials) return '/Images/Common/no_user_photo.png';

		return '';
	};

	const getClassName = () => {
		let className = '';
		if (showOnlineStatus) {
			className += 'online-badge';
			className += isOnline ? ' active' : '';
		}
		return className;
	};

	const getImageSize = () => {
		return typeof size === 'number' ? `${size}px` : size;
	};

	const getWrapperClassName = () => {
		let className = 'biz-user-image-wrapper';
		if (badgePosition !== 'bottom-right') {
			className += ` badge-${badgePosition}`;
		}
		return className;
	};

	return (
		<div
			className={getWrapperClassName()}
			style={{
				width: getImageSize(),
				minWidth: getImageSize(),
				height: getImageSize(),
			}}
		>
			{showOnlineStatus && <div className={getClassName()}></div>}
			<div className='user-profile-circle'>
				{imageUrl && (
					<img
						src={getUserImage()}
						style={{
							width: '100%',
							height: '100%',
							objectFit: 'cover',
						}}
						alt='User avatar'
					/>
				)}
				{!imageUrl && userInitials && (
					<div className='user-initials' style={{ fontSize: `${typeof size === 'number' ? size * 0.4 : '0.4em'}` }}>
						{userInitials}
					</div>
				)}
			</div>
		</div>
	);
};

export default BizUserImage;
